import {
  quizQuestionsTranslations,
  QuizQuestionsTranslations,
} from './quizQuestions/quizQuestions.translation.pl';
import { Quiz409Translations, quizExpiredTranslations } from './409/quizExpired.translation.pl.ts';
import {
  quizScenariosTranslations,
  QuizScenariosTranslations,
} from './quizScenarios/quizScenarios.translation.pl.ts';
import {
  personalDataTranslations,
  PersonalDataTranslations,
} from './personalData/personalData.translation.pl.ts';
import { Http409Code } from '@/api/model/HttpErrorCodes.model.ts';
import { quizFinishedTranslations } from './409/quizFinished.translation.pl.ts';
import { quizToManyRevisitsTranslations } from './409/quizToManyRevisits.translation.pl.ts';
import { quizClosedTranslations } from './409/quizClosed.translation.pl.ts';

type Http409Code = keyof typeof Http409Code;

export type ProcessViewTranslation = {
  quizQuestions: QuizQuestionsTranslations;
  409: Record<Http409Code, Quiz409Translations>;
  quizScenarios: QuizScenariosTranslations;
  personalData: PersonalDataTranslations;
};

export const processViewTranslations: ProcessViewTranslation = {
  quizQuestions: quizQuestionsTranslations,
  409: {
    ['409_1']: quizFinishedTranslations,
    ['409_2']: quizExpiredTranslations,
    ['409_3']: quizToManyRevisitsTranslations,
    ['409_closed']: quizClosedTranslations,
  },
  quizScenarios: quizScenariosTranslations,
  personalData: personalDataTranslations,
};
